import { Link } from 'react-router-dom';

import NavData from '@/config/data/nav/nav_data.json';
import useContent from '@/localization/data_export';

export default function BannerStatic() {
  const anchorTitle = useContent(['global', 'anchor', 'title']);
  return (
    <div className="banner-static">
      <a href="https://company.arirang.com/join/csr" target="_blank" rel="noreferrer" title={anchorTitle}>
        <img src={require('@/assets/images/main/csr_pc.png').default} width={753} height={100} loading="lazy" alt="" />
      </a>
      <Link to={NavData['CALAMITY'].path} title={anchorTitle}>
        <img
          src={require('@/assets/images/main/calamity_banner.png').default}
          width={502}
          height={100}
          loading="lazy"
          alt=""
        />
      </Link>
    </div>
  );
}
